import styled from 'styled-components';
import arrowRight from 'assets/images/arrowRight.svg';
import arrowLeft from 'assets/images/arrowLeft.svg';
import { fonts } from 'styles';
export const Container = styled.div`
  width: 100%;
  margin-bottom: 88px;

  .slick-prev:before,
  .slick-next:before {
    content: '';
    display: none;
  }
  position: relative;

  @media screen and (max-width: 500px) {
    margin-bottom: 56px;
  }
`;

export const ImageWrapper = styled.div`
  padding: 0 4px;

  img {
    width: 100%;
  }
`;

export const Button = styled.button.attrs({ type: 'button' })`
  position: absolute;
  z-index: 99;
  top: calc(50% - 19px);
  transition: 300ms ease;
  display: none;
  &:hover {
    transform: scale(1.1);
  }

  &.left {
    left: 32px;
  }

  &.right {
    right: 32px;
  }

  @media screen and (max-width: 500px) {
    display: block;
    top: calc(50% - 14px);

    &.left {
      left: 12px;
    }
    &.right {
      right: 12px;
    }
  }
`;

export const ArrowLeftIcon = styled.img.attrs({ src: arrowLeft })`
  @media screen and (max-width: 500px) {
    width: 28px;
  }
`;

export const ArrowRightIcon = styled.img.attrs({ src: arrowRight })`
  @media screen and (max-width: 500px) {
    width: 28px;
  }
`;

export const Legend = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 13px;
  line-height: 20px;
  color: #111;
  text-align: center;
  margin-top: 20px;
`;
